import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { PseAvTransaction } from '../models/pseav-transaction';
import { CreditTransaction } from '../models/credit-transaction';
import { BevalidaTransaction } from '../models/bevalida-transaction';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PayService {
  Tc = environment.urlglobal_api + '/api/v3/checkout/tc/transaction';
  TcV3 = environment.urlglobal_api + '/api/v3/checkout/tc/transactionv3';
  TcRb = environment.urlglobal_api + '/api/v3/checkout/tc/rbmtransaction';
  TcPm = environment.urlglobal_api + '/api/v3/checkout/tc/paymenteztransaction';
  Tlfe = environment.urlglobal_api + '/api/v3/checkout/tc/lafisetransaction';

  private tcCB = `${environment.urlglobal_api}/api/v3/checkout/tc/cbcotransaction`;
  private tcCoopenae = `${environment.urlglobal_api}/api/v3/checkout/tc/coopenaetransaction`;
  private configurableList = `${environment.urlglobal_api}/api/v3/checkout/getAntifraudConfigurableList`;
  private tciframeValidation = `${environment.urlglobal_api}/v4/3ds/iframeValidation`;
  private TcNiubiz = `${environment.urlglobal_api}/v4/merchant/transaction/network/niubiz`;
  private tcMovii = `${environment.urlglobal_api}/v4/merchant/transaction/network/movii `;


  constructor(public http: HttpClient) {}

  public tctransaction(data: CreditTransaction) {
    return this.http.post(this.Tc, data).toPromise();
  }

  public tctransactionv3(data: CreditTransaction) {
    return this.http.post(this.TcV3, data).toPromise();
  }

  processPaymentCoopenae(data: CreditTransaction){
    return this.http.post(this.tcCoopenae, data).toPromise();
  }

  /**
   * Funcion para procesar pago por tarjeta de credito con CrediBanco
   * @param CreditTransaction data
   */
  processsPaymentCB(data: CreditTransaction) {
    return this.http.post(this.tcCB, data).toPromise();
  }

  tctransactionRB(parameters) {
    const json = JSON.stringify(parameters);
    return this.http.post(this.TcRb, json).toPromise();
  }

  public processpaymentPM(data: CreditTransaction) {
    return this.http.post(this.TcPm, data).toPromise();
  }

  public processPaymentLafise(data: CreditTransaction) {
    return this.http.post(this.Tlfe, data).toPromise();
  }

  public processPaymentNiubiz(data: CreditTransaction) {
    return this.http.post(this.TcNiubiz, data).toPromise();
  }

  public processPaymentMovii(data: CreditTransaction) {
    return this.http.post(this.tcMovii, data).toPromise();
  }

  public pseTransaction(data: any) {
    return this.http.post(`${environment.urlglobal_api}/api/v3/checkout/pse/transactions`, data).toPromise();
  }

  public pseAvtransaction(parameters: PseAvTransaction) {
    const json = JSON.stringify(parameters);
    return this.http.post(environment.pseav, json);
  }

  /**
   * @description request to endpoint that connects to the wallet for the transaction
   */
  public beValidaTransaction(parameters: BevalidaTransaction) {
    const json = JSON.stringify(parameters);
    return this.http.post(
      `${environment.urlglobal_api}/wallet/loginCashinWallet`,
      json
    ).toPromise();
  }


  public getConfigurableLists(bodyRequest: any): Observable<any> {
    return this.http.post(`${this.configurableList}`, bodyRequest);
  }

  public iframeValidation(bodyRequest: any):Observable <any> {
    return this.http.post(`${this.tciframeValidation}`, bodyRequest);
  }

  verifyPaymentezTransaction(requestBody: any): Observable<any> {
    return this.http.post<any>(
      `${environment.urlglobal_api}/api/v3/checkout/tc/verifypaymenteztransaction`,requestBody
    );
  }

}
